import { AdministrationGroupInfoResponseModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group-info.response-model';
import { AdministrationGroupMemberItemResponseModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group-member-item.response-model';
import { AdministrationGroupViewModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group.view-model';

export class ToAdministrationGroupViewModelMapper {
  public handle(
    groupInfo: AdministrationGroupInfoResponseModel,
    members: AdministrationGroupMemberItemResponseModel[],
  ): AdministrationGroupViewModel {
    const viewModel: AdministrationGroupViewModel = new AdministrationGroupViewModel();

    viewModel.groupName = groupInfo.displayName;

    viewModel.members = members.map((item) => item.displayName);

    return viewModel;
  }
}
